import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface SearchErrorProps {
  message: string;
  errorCode?: string | null;
  onReset: () => void;
}

export function SearchError({ message, errorCode, onReset }: SearchErrorProps) {
  return (
    <Card aria-live="assertive" className="bg-background/40">
      <CardContent className="space-y-4 py-5">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 size-4 text-destructive" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">Search failed</p>
            <p className="text-sm text-muted-foreground">{message}</p>
            {errorCode ? <p className="text-xs uppercase tracking-[0.16em] text-muted-foreground">{errorCode}</p> : null}
          </div>
        </div>
        <Button variant="outline" onClick={onReset}>
          Back to search
        </Button>
      </CardContent>
    </Card>
  );
}
